import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppService } from './app.service';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.css']
})
export class WelcomeComponent implements OnInit {


  guideText = ""
  iframeMode = true

  authSub: Subscription

  constructor(private serv: AppService, private router: Router) {
  
   }

  ngOnInit(): void {
    this.authSub = this.serv.isLoggedIn$.subscribe(x => {
      if (x) {
        this.router.navigate(['/allgear'])
      }
    })

    this.serv.welcomeInit().subscribe(ret => {
      this.guideText = ret['guideText']
      this.iframeMode = ret['iframeMode']
    })
  }

  ngOnDestroy() {
    this.authSub.unsubscribe()
  }
}
